<h2>Hozzáadott felhasználók:</h2>
<div *ngFor="let item of userList;">
    <p>{{item.firstName}} {{item.lastName}}</p>
    <button *ngIf="projectService.canManageUsers(project, user, projectPermission)" class="mat-raised-button" (click)="removeUser(item)">Törlés</button>
    <button *ngIf="projectService.canManageUsers(project, user, projectPermission)" class="mat-raised-button" (click)="perms(item)">Jogosultságok</button>
</div>

